/**
 * @generated SignedSource<<f738b5af1c3199cf672ce4fa561b05c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FundsListDownload_fundsListDownload$data = {
  readonly label: string | null | undefined;
  readonly url: string;
  readonly " $fragmentType": "FundsListDownload_fundsListDownload";
};
export type FundsListDownload_fundsListDownload$key = {
  readonly " $data"?: FundsListDownload_fundsListDownload$data;
  readonly " $fragmentSpreads": FragmentRefs<"FundsListDownload_fundsListDownload">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FundsListDownload_fundsListDownload",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "type": "SimpleLink",
  "abstractKey": null
};

(node as any).hash = "d9c45362b4e9b2296e819a94b7c96073";

export default node;
